import styled from 'styled-components/macro';
import { Flex, Box } from '@stashinvest/ui/dist/es/2';
import { OrderedList } from '@stashinvest/ui';

export const OrderedListContainer = styled(OrderedList)`
	line-height: 32px;
	li {
		list-style-position: inside;
	}
`;

export const BoxContainer = styled(Box)`
	${(props) => {
		if (props.isMobile) {
			return `
        text-align: left;
        ol {
          padding: 0;
          line-height: 20px;
          li {
            padding-bottom: 20px
          }
        }
      `;
		}
	}}
`;

export const FlexContainer = styled(Flex)`
	${(props) => {
		if (props.isMobile) {
			return `
          display: block;
        `;
		}
	}}
`;
